const API_URL = 'https://www.youtube.com/iframe_api';

function waitForYouTubePlayerApi() {
  return new Promise(resolve => {
    if (window.YT && window.YT.loaded) {
      resolve();
    } else {
      window.onYouTubeIframeAPIReady = resolve;
    }
  });
}

function loadExternalScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = url;

    script.onload = () => resolve();

    script.onerror = () => reject();

    document.head.appendChild(script);
  });
}

export { API_URL, loadExternalScript, waitForYouTubePlayerApi };
